module.exports = __webpack_public_path__ + "img/list_Story_13.6b7acde6.jpeg";